import { graphql } from '../graphql';

export const updateProjectMutation = graphql(`
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      name
      description
      srid
    }
  }
`);

export const createProjectLinkMutation = graphql(`
  mutation CreateProjectLink($projectId: ID!, $expiresAt: DateTime!, $name: String!) {
    createProjectLink(projectId: $projectId, expiresAt: $expiresAt, name: $name) {
      id
      projectId
      token
      expiresAt
      createdAt
      createdById
      createdBy {
        id
        name
        email
      }
    }
  }
`);

export const deleteProjectLinkMutation = graphql(`
  mutation DeleteProjectLink($id: ID!) {
    deleteProjectLink(id: $id)
  }
`);

export const deleteProjectMutation = graphql(`
  mutation DeleteProject($id: ID!) {
    deleteProject(id: $id)
  }
`);
